export const PRODUCT_UNIT_OPTIONS = [
  "szt",
  "op",
  "kg",
  "kpl",
  "m",
  "m2",
  "m.b.",
  "km",
  "litr",
  "paczka",
  "para",
  "box",
  "rol",
  "pal",
  "godz",
  "usługa",
] as const
